// Classifica uma variavel em uma "familia" baseada no ihmname/name.
// As familias agrupam variaveis correlatas (todas as Temperatura* juntas,
// todas as Vibracao* juntas) — operador encontra do que precisa muito
// mais rapido do que numa lista plana de ~300 itens.
//
// A ordem do array FAMILIES define a ordem que as secoes aparecem na UI.

export const FAMILIES = [
  { key: 'temperatura', label: 'Temperatura', match: /^temperatura/i },
  { key: 'vibracao', label: 'Vibração', match: /^vibracao/i },
  { key: 'pressao', label: 'Pressão', match: /^pressao/i },
  { key: 'corrente', label: 'Corrente', match: /^corrente/i },
  { key: 'tensao', label: 'Tensão', match: /^tensao/i },
  { key: 'potencia', label: 'Potência', match: /^potencia/i },
  { key: 'energia', label: 'Energia', match: /^energia/i },
  { key: 'fator', label: 'Fator de Potência', match: /^fator/i },
  { key: 'vazao', label: 'Vazão', match: /^vazao/i },
  { key: 'nivel', label: 'Nível', match: /^nivel/i },
  { key: 'rotacao', label: 'Rotação', match: /^rotacao/i },
  { key: 'frequencia', label: 'Frequência', match: /^frequencia/i },
  { key: 'alarme', label: 'Alarmes e Bloqueios', match: /^(alarme|bloqueio|advertencia|erro|falha)/i },
  { key: 'sp', label: 'Setpoints e Limites', match: /^(sp_|alm_h_|alm_l_)/i },
  { key: 'outros', label: 'Outros', match: /.*/ },
];

// Retorna a chave da familia que melhor classifica a variavel. Sempre
// retorna algo (fallback 'outros').
export const getVariableFamily = (variable) => {
  if (!variable) return 'outros';
  const id = variable.ihmname || variable.name || '';
  const family = FAMILIES.find((f) => f.match.test(id));
  return family ? family.key : 'outros';
};

// Helper pra obter label legivel da familia a partir da key.
export const getFamilyLabel = (familyKey) => {
  const f = FAMILIES.find((x) => x.key === familyKey);
  return f ? f.label : 'Outros';
};
